import { render, staticRenderFns } from "./WorkspaceNodeExpressionPanel.vue?vue&type=template&id=58e8cb68&scoped=true"
import script from "./WorkspaceNodeExpressionPanel.vue?vue&type=script&lang=js"
export * from "./WorkspaceNodeExpressionPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceNodeExpressionPanel.vue?vue&type=style&index=0&id=58e8cb68&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e8cb68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e8cb68')) {
      api.createRecord('58e8cb68', component.options)
    } else {
      api.reload('58e8cb68', component.options)
    }
    module.hot.accept("./WorkspaceNodeExpressionPanel.vue?vue&type=template&id=58e8cb68&scoped=true", function () {
      api.rerender('58e8cb68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceNodeExpressionPanel.vue"
export default component.exports